module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "flex-align-center flex-pack-center",
    attrs: {
      "type": "flex"
    }
  }, [_c('div', {
    staticClass: "addStore"
  }, [(_vm.isEnterInviteCode) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("请输入邀请码")]) : _vm._e(), _vm._v(" "), (!_vm.isEnterInviteCode) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("添加店铺")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "back",
    on: {
      "click": function () {
        _vm.$router.push({
          path: '/login'
        })
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-return"
  }), _vm._v(" "), _c('span', [_vm._v("返回")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.isEnterInviteCode) ? _c('div', {
    staticClass: "inviteCode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.referralCode),
      expression: "newStore.referralCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入您的邀请码"
    },
    domProps: {
      "value": (_vm.newStore.referralCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkInviteCode.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "referralCode", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isEnterInviteCode) ? _c('div', {
    staticClass: "storeMsg"
  }, [_c('div', {
    staticClass: "storeMsgItem nameInput"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.name),
      expression: "newStore.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入店铺名"
    },
    domProps: {
      "value": (_vm.newStore.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "storeMsgItem"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择店铺类型"
    },
    model: {
      value: (_vm.newStore.typeId),
      callback: function($$v) {
        _vm.$set(_vm.newStore, "typeId", $$v)
      },
      expression: "newStore.typeId"
    }
  }, _vm._l((_vm.storeType), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "storeMsgItem addrInput"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.addr),
      expression: "newStore.addr"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入地址"
    },
    domProps: {
      "value": (_vm.newStore.addr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "addr", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "confirmBtn"
  }, [(_vm.isEnterInviteCode) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.checkInviteCode
    }
  }, [_vm._v("下一步")]) : _vm._e(), _vm._v(" "), (!_vm.isEnterInviteCode) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addStore,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addStore.apply(null, arguments)
      }
    }
  }, [_vm._v("下一步")]) : _vm._e()])])]), _vm._v(" "), (_vm.isFirstAddStore) ? _c('div', {
    staticClass: "noStoreMask"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/logo-white.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "noStoreBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("添加店铺")]), _vm._v(" "), _c('div', {
    staticClass: "tipText"
  }, [_vm._v("暂无相关店铺数据，请新建店铺信息")]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isFirstAddStore = false
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-add"
  }), _vm._v("\n                    新建店铺\n                ")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1c292d25","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/addStore/addStore.vue
// module id = 928
// module chunks = 1